import { render } from "./ItemHeader.vue?vue&type=template&id=2bf0d8d4&ts=true"
import script from "./ItemHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemHeader.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/item/ItemHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bf0d8d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bf0d8d4', __exports__)) {
    api.reload('2bf0d8d4', __exports__)
  }
  
  module.hot.accept("./ItemHeader.vue?vue&type=template&id=2bf0d8d4&ts=true", () => {
    api.rerender('2bf0d8d4', render)
  })

}


export default __exports__